import { Link } from "react-router-dom"
import { useGuardiansPassport } from "@/features/passport/GuardiansPassportContext"
import { PLAY_HUB_LINKS } from "@/features/play/hubLinks"

/** Бывший HomeTab — полный список режимов. */
export default function HubPage() {
  const { passport } = useGuardiansPassport()
  const groups = [...new Set(PLAY_HUB_LINKS.map((l) => l.group))]

  return (
    <div className="px-4 py-6">
      <h1 className="text-xl font-semibold text-guardians-accent">Все режимы</h1>
      {passport ? (
        <p className="mt-2 text-sm text-guardians-muted">
          {passport.nickname} · 🪙 {passport.coins ?? 0}
        </p>
      ) : null}
      <div className="mt-6 space-y-6">
        {groups.map((group) => (
          <section key={group}>
            <h2 className="mb-2 text-xs font-semibold uppercase tracking-wide text-guardians-muted">
              {group}
            </h2>
            <ul className="space-y-1">
              {PLAY_HUB_LINKS.filter((l) => l.group === group).map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="block rounded-lg px-3 py-2 text-sm hover:bg-white/5"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </section>
        ))}
      </div>
    </div>
  )
}
